import { CONTEST_LIST_SUCCESS, IS_LOADING, CONTEST_ADD_SUCCESS, USER_VERIFICATION_SUCCESS,CONTEST_STATUS_CHANGED_SUCCESS,CONTEST_STATUS_CHANGED_ERROR, CONTEST_ACTIVE_SUCCESS, } from "../actions/Type";

const initialState = {
    contest_list: {},
    loading: false,
    contest_add : {}, 
    contest_status_changed : {}
}

const ContestsReducers = (state = initialState, { type, payload } = {}) => {
    // console.log("payload", payload);
    switch (type) {
        case IS_LOADING:
            return {
                ...state,
                loading: true
            }
        case CONTEST_LIST_SUCCESS:
            return {
                ...state,
                contest_list: payload,
                loading: false
            }
            case CONTEST_ACTIVE_SUCCESS:
                return {
                    ...state,
                    active_contest: payload,
                    loading: false
                }
        case CONTEST_ADD_SUCCESS:
            return {
                ...state,
                contest_add: payload,
                loading: false
            }

            case CONTEST_STATUS_CHANGED_SUCCESS:
                return {
                    ...state,
                    contest_status_changed: payload,
                    loading: false
                }
                case CONTEST_STATUS_CHANGED_ERROR:
                return {
                    ...state,
                    contest_status_changed: payload,
                    loading: false
                }
        // case USER_VERIFICATION_SUCCESS:
        //     return {
        //         ...state,
        //         user_verification: payload,
        //         loading: false
        //     }
        default:
            return state
    }
}

export default ContestsReducers